import de from '../../public/lang/de.json'

export default de
